import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Spinner, Alert, Accordion, Tabs, Tab } from "react-bootstrap";
import "./TagStyle.css";
import "./HomePage.css";
import axios from "../AxiosConfig";

const HomePage = () => {
  const [tags, setTags] = useState({
    My_org_collects: [],
    collaborativeInterests: [],
    regions: [],
    countries: [],
  });

  const [selectedTags, setSelectedTags] = useState({
    My_org_collects: [],
    collaborativeInterests: [],
    regions: [],
    countries: [],
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [activeTab, setActiveTab] = useState("search");
  const [textSearchQuery, setTextSearchQuery] = useState("");

  const noHttps = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };

  useEffect(() => {
    const fetchTags = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/api/search/get_tags");
        setTags(response.data.tags);
      } catch (err) {
        console.error("Error fetching tags:", err);
        setError("Failed to load dropdown options. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchTags();
  }, []);

  const calculateTagMatches = (selectedTags, orgTags) => {
    const selectedTagIds = Object.values(selectedTags).flat().map((tag) => String(tag.id));
    const orgTagIds = orgTags.map((tag) => String(tag.tag_id));
    return selectedTagIds.filter((id) => orgTagIds.includes(id)).length;
  };

  const handleTagSelect = (e, tagType) => {
    const tagId = e.target.value;
    const tagName = e.target.options[e.target.selectedIndex].text;

    if (tagId && !selectedTags[tagType].some((tag) => tag.id === tagId)) {
      setSelectedTags((prev) => ({
        ...prev,
        [tagType]: [...prev[tagType], { id: tagId, name: tagName }],
      }));
    }
  };

  const handleTagRemove = (tagId, tagType) => {
    setSelectedTags((prev) => ({
      ...prev,
      [tagType]: prev[tagType].filter((tag) => tag.id !== tagId),
    }));
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const searchData = activeTab === "search"
      ? { textQuery: textSearchQuery }
      : {
          My_org_collects: selectedTags.My_org_collects.map((tag) => tag.id),
          collaborativeInterests: selectedTags.collaborativeInterests.map((tag) => tag.id),
          regions: selectedTags.regions.map((tag) => tag.id),
          countries: selectedTags.countries.map((tag) => tag.id),
        };

    try {
      const response = await axios.post("/api/search/submit_search", searchData);
      setSearchResults(response.data.results);
    } catch (err) {
      console.error("Error submitting search query:", err);
    } finally {
      setSearchPerformed(true);
    }
  };

  if (loading) return <Spinner animation="border" className="mt-5" />;
  if (error) return <Alert variant="danger" className="mt-5">{error}</Alert>;

  const headers = {My_org_collects: "Collects Data About",
                   collaborativeInterests: "Collaborative Interests",
                   regions: "Regions",
                   countries: "Countries",
                  };

  return (
    <Container>
      <header className="csr-logo-header">
        <div className="logo-grid">
          <div className="logo-item">
            <div className="half-box yellow"></div>
            <div className="half-box blue">
              <span className="centered-text">C</span>
            </div>
          </div>
          <div className="logo-item">
            <div className="half-box blue"></div>
            <div className="half-box coral">
              <span className="centered-text">S</span>
            </div>
          </div>
          <div className="logo-item">
            <div className="half-box teal"></div>
            <div className="half-box blue">
              <span className="centered-text">R</span>
            </div>
          </div>
        </div>
        <p className="logo-subtext">METAPORTAL</p>
      </header>
      <Tabs activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)} className="mb-4">
        <Tab eventKey="search" title="Search">
          <Form onSubmit={handleSearch} className="mt-4">
            <Form.Group>
              <Form.Label>Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Type your search query"
                value={textSearchQuery}
                onChange={(e) => setTextSearchQuery(e.target.value)}
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              Search
            </Button>
          </Form>
        </Tab>
        <Tab eventKey="tagSearch" title="Tag Search">
          <Form onSubmit={handleSearch} className="mt-4">
            <Row className="mb-4">
              {Object.keys(tags).map((tagType) => (
                <Col xs={12} md={6} key={tagType} className="mb-3">
                  <Form.Group>
                    <Form.Label>{headers[tagType]}</Form.Label>
                    <Form.Control as="select" onChange={(e) => handleTagSelect(e, tagType)} value="">
                      <option value="">Select {headers[tagType]}</option>
                      {tags[tagType].map((tag) => (
                        <option key={tag.id} value={tag.id}>
                          {tag.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <ul className="d-flex flex-wrap list-unstyled mt-2">
                    {selectedTags[tagType].map((tag) => (
                      <li key={tag.id} className="tag-style">
                        <span className="me-2">{tag.name}</span>
                        <button
                          type="button"
                          className="btn-close btn-sm btn-close-white"
                          aria-label={`Remove ${tag.name}`}
                          onClick={() => handleTagRemove(tag.id, tagType)}
                          style={{ fontSize: "0.8rem" }}
                        ></button>
                      </li>
                    ))}
                  </ul>
                </Col>
              ))}
            </Row>
            <Button variant="primary" type="submit" className="mt-3">
              Search
            </Button>
          </Form>
        </Tab>
      </Tabs>
      <Row className="mt-4">
        <Col>
          {searchPerformed && <h3>Search Results</h3>}
          {searchPerformed && searchResults.length > 0 ? (
            <Accordion className="mb-5">
              {searchResults.map((org, index) => (
                <Accordion.Item eventKey={`${org.org_id}-${index}`} key={`${org.org_id}-${index}`}>
                  <Accordion.Header>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                      <span>{org.org_name}: {org.tags.find((tag) => tag.tag_category_id === 4)?.tag_name}</span>
                      {activeTab === "tagSearch" && (
                        <span>
                          {calculateTagMatches(selectedTags, org.tags)} Tag
                          {calculateTagMatches(selectedTags, org.tags) === 1 ? '' : 's'} Matched
                        </span>
                      )}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>{org.for_profit ? "For Profit" : "Not For Profit"}</p>
                    <p><strong>Summary</strong></p>
                    {org.org_summary && <p>{org.org_summary}</p>}

                    <Row>
                      <Col>
                        {org.branch && <p><strong>Branch:</strong> {org.branch}</p>}
                        {org.org_url && (
                          <p><strong>URL:</strong> <a href={noHttps(org.org_url)} target="_blank" rel="noopener noreferrer">{org.org_url}</a></p>
                        )}
                        {org.db_url && (
                          <p><strong>Database URL:</strong> <a href={noHttps(org.db_url)} target="_blank" rel="noopener noreferrer">{org.db_url}</a></p>
                        )}
                        <strong>Country:</strong>{" "}
                        {org.tags
                          .filter((tag) => tag.tag_category_id === 4)
                          .map((tag, index, array) => (
                            <span key={`${tag.tag_id}-${index}`}>
                              {tag.tag_name}
                              {index < array.length - 1 ? ", " : ""}
                            </span>
                          ))}
                      </Col>
                      <Col>
                        {(org.contact_person || org.contact_email || org.contact_phone) && (
                          <>
                            <p><strong>Contact</strong></p>
                            {org.contact_person && <p>{org.contact_person} ({org.contact_person_role || "No role specified"})</p>}
                            {org.contact_email && <p><a href={`mailto:${org.contact_email}`}>{org.contact_email}</a></p>}
                            {org.contact_phone && <p>{org.contact_phone}</p>}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <h5>Organization Collects</h5>
                        <ul>
                          {org.tags.filter((tag) => tag.tag_category_id === 1).map((tag) => (
                              <li key={tag.tag_id} className="tag-style">{tag.tag_name}</li>
                            ))}
                        </ul>
                      </Col>
                      <Col>
                        <h5>Collaborative Interests</h5>
                        <ul>
                          {org.tags.filter((tag) => tag.tag_category_id === 2).map((tag) => (
                              <li key={tag.tag_id} className="tag-style">{tag.tag_name}</li>
                            ))}
                        </ul>
                      </Col>
                      <Col>
                        <h5>Region</h5>
                        <ul>
                          {org.tags.filter((tag) => tag.tag_category_id === 3).map((tag) => (
                              <li key={tag.tag_id} className="tag-style">{tag.tag_name}</li>
                            ))}
                        </ul>
                      </Col>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : searchPerformed && (
            <p>No results found.</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default HomePage;
